import React, { CSSProperties } from 'react';
import { useApolloClient } from '@apollo/client';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useArchiveTagListMutation, useRestoreTagListMutation } from '../../../generated/graphql';

type TagArchiveDialogProps = {
    ids: string[];
    mode: 'archive' | 'restore';
    onClose: () => void;
    visible: boolean;
    style?: CSSProperties;
};

const TagArchiveDialog = ({ ids, mode, onClose, visible, style }: TagArchiveDialogProps) => {
    const apolloClient = useApolloClient();
    const [archiveTags, archiveResult] = useArchiveTagListMutation();
    const [restoreTags, restoreResult] = useRestoreTagListMutation();
    const isRestore = mode === 'restore';

    const handleConfirm = async () => {
        const mutate = isRestore ? restoreTags : archiveTags;
        await mutate({ variables: { ids } });
        await apolloClient.resetStore();
        onClose();
    };

    return (
        <DialogBase
            title={`${isRestore ? 'Restore' : 'Archive'} Tags`}
            type="YesNo"
            visible={visible}
            onClose={onClose}
            onYesClick={handleConfirm}
            confirmLabel={isRestore ? 'Restore' : 'Archive'}
            isLoading={archiveResult.loading || restoreResult.loading}
            style={style}
            data-testid="TagArchiveDialog">
            <p style={{ color: 'var(--text-secondary)' }}>
                {isRestore
                    ? 'Restore the selected tags? They will become available for selection again.'
                    : 'Archive the selected tags? Existing references will be preserved, but the tags will be hidden everywhere until restored.'}
            </p>
        </DialogBase>
    );
};

export default TagArchiveDialog;
